import React, {useState, useEffect} from "react";
import Header from "../Components/Header";
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
ReactSession.setStoreType("localStorage");


const Productenquery = () => {
   const navigate = useNavigate();
  const userId=ReactSession.get("welbeingId");
  const [enquery, setenquery] = useState([]);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
 const [rowsPerPage2, setRowsPerPage2] = useState(10); // Items per page


 if(userId  <= 0 ){
      navigate('/login');
   }

// Calculate total pages


const handlePageChange = (event, newPage) => {
  event.preventDefault();
  if (newPage >= 1 && newPage <= totalPages) {
    setPage(newPage);
  }
};

const totalPages = Math.ceil(enquery.length / rowsPerPage2);
const currentData = enquery.slice(
  (page - 1) * rowsPerPage2, 
  page * rowsPerPage2
);

  useEffect(() => {
    const enquery = async() =>{
        try{
            const response = await axios.get('https://projects.sninfoserv.com/welb-api/admin/enquries/get-product/');
            console.log(response.data);
            if(response.data.status==="success"){
            
            setenquery(response.data.data);
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };
       enquery();
    }, []);



   

    return(

        <>
      
        <Header/>
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        
        
           <div class="body-wrapper">
            
        
             <div class="container-fluid">
       
        <div class="card bg-light-info shadow-none position-relative overflow-hidden">
            <div class="card-body px-4 py-3">
              <div class="row align-items-center">
                <div class="col-9">
                  <h4 class="fw-semibold mb-8">Product Enquries</h4>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a class="text-muted" href="dashboard.php">Dashboard</a></li>
                      <li class="breadcrumb-item" aria-current="page">Product Enquries</li>
                    </ol>
                  </nav>
                </div>
                <div class="col-3">
                  <div class="text-center mb-n5">  
                    <img src="dist/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Section  */}
        <section>
           
            <div class="row">
              <div class="col-12">
                <div class="card">
				  
                  <div class="card-body">
				           <h4>Product Enquries</h4>
                    <div class="mb-2">
                      <h5 class="mb-0"></h5>
                    </div>
                    <div class="table-responsive">
                     <section>
           
            <div class="row">
                  {currentData.map((enquery) => (
                 <div class="col-lg-3 col-12">
                    <div class="card" style={{minHeight: '200px'}}>
                        <div class="card-body">
                            <h5>{enquery.name}</h5>
                            <p>{enquery.phonenumber}</p>
                            <p>{enquery.email}</p>
                            <p>{enquery.description}</p>
                            <hr/>
                            <small>{enquery.date}</small>
                        </div>
                    </div>
                 </div>

               ))}
   
    

               <div className="row">
                  <div className="col-12">
                    <nav>
                      <ul className="pagination justify-content-end">
                        {/* Previous */}
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={(e) => handlePageChange(e, page - 1)}
                            disabled={page === 1}
                          >
                            « Previous
                          </button>
                        </li>
                
                
                        {/* Visible page numbers */}
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                          .filter(p => p === 1 || p === totalPages || Math.abs(page - p) <= 2)
                          .map(p => (
                            <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                              <button className="page-link" onClick={(e) => handlePageChange(e, p)}>
                                {p}
                              </button>
                            </li>
                          ))}
                
                        {/* Show ... and last page if current page < totalPages - 2 */}
                        {page < totalPages - 2 && (
                          <>
                            <li className="page-item disabled">
                              <span className="page-link">...</span>
                            </li>
                            <li className="page-item">
                              <button className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>
                                {totalPages}
                              </button>
                            </li>
                          </>
                        )}
                
                        {/* Next */}
                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={(e) => handlePageChange(e, page + 1)}
                            disabled={page === totalPages}
                          >
                            Next »
                          </button>
                        </li>
                      </ul>
                    </nav>
                 </div>
              </div>
                         
             </div>
            </section>
            </div>
               
              </div>
            </div>
          </div></div></section>
             </div>
            </div>
        </div>
        </>
    )
}
export default Productenquery;